import React, {useEffect, useRef, useState} from 'react';
import './ChatWidget.css';
import {io} from 'socket.io-client';
const getBaseUrl = () => {
    if (process.env.CHAT_URL) {
        return process.env.CHAT_URL;
    }
    return 'https://server.epoxygarden.com';
};

export const WS_BASE = getBaseUrl();
// const WS_BASE = 'https://server.epoxygarden.com';
const socket = io(WS_BASE, {
    autoConnect: false,
});
let room = 'message';



// Generate a stable client ID and persist it so the path can be /ws/:id
const getClientId = () => {
    try {
        const key = 'chatClientId';
        let id = localStorage.getItem(key);
        if (!id) {
            id = Math.random().toString(36).slice(2) + Date.now().toString(36);
            localStorage.setItem(key, id);
        }
        return id;
    } catch (e) {
        // Fallback if localStorage is not available
        return Math.random().toString(36).slice(2) + Date.now().toString(36);
    }
};

const CLIENT_ID = getClientId();



const ChatWidget = () => {
    const socketRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [messages, setMessages] = useState([
        {from: 'Gulfiya', text: 'Hi! How can we help you today?'}
    ]);


    useEffect(() => {

        socketRef.current = socket;

        socket.on('connect', () => {
            setConnected(true);
        });

        socket.on('disconnect', () => {
            setConnected(false);
        });

        socket.on('message', (...args) => {
            console.log('Received message args:', args);
            // The server seems to send: (message, fromName, clientId, type)
            // or sometimes it might be different. Let's handle both based on original code.
            let message, fromName, clientId, type;

            if (args.length === 1 && typeof args[0] === 'object') {
                // Handle object payload if server sends one
                ({message, fromName, clientId, type} = args[0]);
            } else {
                [message, fromName, clientId, type] = args;
            }

            if (type === 'send' && clientId !== CLIENT_ID) {
                setMessages((prev) => [...prev, {from: fromName || 'Support', text: message}]);
            } else if (type !== 'send' && message) {
                setMessages((prev) => [...prev, {from: 'System', text: message}]);
            }
        });

        return () => {
            socket.disconnect();
            socket.off();
        };
    }, []);

    useEffect(() => {
        // No longer persisting messages to localStorage
    }, [messages]);
    const [input, setInput] = useState('');
    const [clientName, setClientName] = useState(localStorage.getItem('chatClientName') || '');
    const [showNameInput, setShowNameInput] = useState(!localStorage.getItem('chatClientName'));
    const [connected, setConnected] = useState(false);
    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({behavior: "smooth"});
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages, open, showNameInput]);

    // connect websocket only when chat is open
    useEffect(() => {
        // If chat is closed, ensure socket is disconnected
        if (open) {
            socketRef.current?.connect();
        } else {
            socketRef.current?.disconnect();
        }
        // Clear messages when chat is opened
        setMessages([
            {from: 'Gulfiya', text: 'Hi! How can we help you today?'}
        ]);
        localStorage.removeItem('chatMessages');
    }, [open]);

    useEffect(() => {
        const handleOpenChat = () => setOpen(true);
        window.addEventListener('openChat', handleOpenChat);
        return () => window.removeEventListener('openChat', handleOpenChat);
    }, []);

    const toggle = () => setOpen((v) => !v);

    const handleClearChat = () => {
        const initialMessages = [
            {from: 'Gulfiya', text: 'Hi! How can we help you today?'}
        ];
        setMessages(initialMessages);
        localStorage.removeItem('chatMessages');
    };

    const handleNameSubmit = (e) => {
        e.preventDefault();
        const name = clientName.trim();
        if (name) {
            localStorage.setItem('chatClientName', name);
            setShowNameInput(false);
        }
    };

    const handleSend = (e) => {
        e.preventDefault();
        const text = input.trim();
        if (!text) return;

        const fullText = clientName ? `[${clientName.toLowerCase()}]: ${text}` : text;

        // show user message immediately
        setMessages((prev) => [...prev, {from: 'user', text: fullText}]);
        setInput('');

        // Send command to server via Socket.IO
        if (socketRef.current?.connected) {
            try {
                socketRef.current.emit(room, CLIENT_ID, clientName.toLowerCase(), text);
            } catch (err) {
                // If send fails, reflect in chat
                setMessages((prev) => [...prev, {from: 'Gulfiya', text: 'Failed to send message.'}]);
            }
        }
    };

    return (
        <div className="chat-widget" aria-live="polite">
            {open && (
                <div id="chat-panel" className="chat-panel" role="dialog" aria-label="Chat widget" aria-modal="false">
                    <div className="chat-header">
                        <div className="chat-header-info">
                            <strong>Support</strong>
                            <div className="chat-subtitle">{connected ? 'Online' : 'Offline'} • Typically replies in a
                                few minutes
                            </div>
                        </div>
                        <div className="chat-header-actions">
                            <button className="chat-clear" onClick={handleClearChat} title="Clear chat"
                                    aria-label="Clear chat">🗑️
                            </button>
                            <button className="chat-close" onClick={toggle} aria-label="Close chat">×</button>
                        </div>
                    </div>
                    <div className="chat-messages">
                        {messages.map((m, i) => (
                            <div key={i} className={`chat-msg ${m.from === 'user' ? 'user' : 'bot'}`}>
                                {m.text}
                            </div>
                        ))}
                        <div ref={messagesEndRef}/>
                        {showNameInput && (
                            <div className="chat-name-prompt">
                                <p>Please enter your name to start chatting:</p>
                                <form className="chat-name-form" onSubmit={handleNameSubmit}>
                                    <input
                                        type="text"
                                        placeholder="Your name"
                                        value={clientName}
                                        onChange={(e) => setClientName(e.target.value)}
                                        required
                                        autoFocus
                                    />
                                    <button type="submit" className="send-btn">Start Chat</button>
                                </form>
                            </div>
                        )}
                    </div>
                    {!showNameInput && (
                        <form className="chat-input-row" onSubmit={handleSend}>
                            <input
                                type="text"
                                placeholder={connected ? 'Type your message...' : 'Type your message... (press Send to queue)'}
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                aria-label="Chat message"
                            />
                            <button type="submit" className="send-btn" aria-label="Send message">Send</button>
                        </form>
                    )}
                </div>
            )}
            <button className="chat-fab" onClick={toggle} aria-expanded={open} aria-controls="chat-panel">
                {open ? '−' : '💬'}
            </button>
        </div>
    );
};

export default ChatWidget;
